export default __webpack_public_path__ + "assets/icons/symbol-add.d6ae54cb.svg";